import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-page-navigation',
  templateUrl: './page-navigation.component.html'
})
export class PageNavigationComponent {

  @Input() pageNumber: number;
  @Input() totalPages: number;

  @Output() movePage = new EventEmitter<number>();

  constructor() {
  }

  increasePage() {
    this.movePage.emit(1);
  }

  decreasePage() {
    this.movePage.emit(-1);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/widgets/page-navigation/page-navigation.component.ts